import { Cryptocurrency } from '#src/__generated__/globalTypes.ts';
import { CryptoIcon } from '#src/atoms/icons/CryptoIcon/index.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelM, LabelXS } from '#src/atoms/typography/index.tsx';
import { Dots } from '#src/atoms/ui/Dots/index.tsx';
import { useIntlContext } from '#src/contexts/intl/index.ts';
import { useCryptoBalance } from '#src/hooks/useCryptoBalance.ts';

const fallback = {
  [Cryptocurrency.WEI]: '0 ETH',
  [Cryptocurrency.LAMPORT]: '0 SOL',
};

type Props = { collapsed?: boolean };

export const CryptoBalance = ({ collapsed }: Props) => {
  const { formatNumber } = useIntlContext();
  const { hideBalance, cryptocurrency, balanceInCrypto, roundedCryptoValue } =
    useCryptoBalance(collapsed);

  if (collapsed) {
    return (
      <Vertical gap={0.5} center>
        <CryptoIcon cryptocurrency={cryptocurrency} />
        <LabelXS bold>
          {hideBalance ? (
            <Dots count={3} size="small" />
          ) : (
            formatNumber(roundedCryptoValue, {
              notation: 'compact',
              compactDisplay: 'short',
              maximumFractionDigits: 2,
            })
          )}
        </LabelXS>
      </Vertical>
    );
  }

  return hideBalance ? (
    <Horizontal center>
      <CryptoIcon cryptocurrency={cryptocurrency} />
      <Horizontal gap={0.5}>
        <Dots count={3} size="small" />
      </Horizontal>
    </Horizontal>
  ) : (
    <LabelM bold>{balanceInCrypto || fallback[cryptocurrency]}</LabelM>
  );
};
